import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Configurația ta Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDK7NTLjdFBTOCHU6gqj7mFzhPkmI8JGDQ",

  authDomain: "firu-artei-46c38.firebaseapp.com",

  projectId: "firu-artei-46c38",

  storageBucket: "firu-artei-46c38.firebasestorage.app",

  messagingSenderId: "741689959449",

  appId: "1:741689959449:web:ff038bee90b8f2722af688",

  measurementId: "G-WWY9ZMS1BL",
};

// Inițializează Firebase
const app = initializeApp(firebaseConfig);

// Creează obiectele `auth` și `db`
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

// Exportă aceste obiecte pentru a fi folosite în alte fișiere
export { db, auth, storage };
